import { Typography } from '@material-ui/core';
import duvidasApi, { Duvida } from 'api/Assessor/duvidas';
import { DialogIcon } from 'components/Icons';
import { formatCPFOrCNPJ } from 'helpers/utils/cpfCnpjMask';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import translation from 'locales/translation';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from 'store/Reducer';
import ChatContext from './ChatContext';
import Question from './Duvida';
import Responder from './Responder';
import './styles.scss';

const rootClassName = 'chat-assessor';

interface IToggleResponse {
  idDuvida: number | any;
  flgEmEdicao: boolean;
  flgEmResposta: boolean | any;
}

export const toggleResponse = (
  obj: IToggleResponse,
  callbackSuccess?: (e?: any) => void,
  callbackError?: (e?: any) => void
) => {
  duvidasApi
    .alterarEmResposta(obj)
    .then((r) => {
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(r);
      }
    })
    .catch((fail) => {
      if (typeof callbackError === 'function') {
        callbackError(fail);
      }
      ErrorHandler(fail);
    });
};

export default function Chat() {
  const { conversaAtual } = useContext(MensagensContext);
  const [duvidaAtual, setDuvida] = useState<Duvida>();
  const [respostaPadraoResponse, setRespostaPadraoResponse] = useState<any>();
  const { usuario } = useSelector((state: IReducer) => state.auth);
  // const { evento } = useSelector(
  //   (state: IReducer) => state.assembleiasAssessor
  // );

  const NenhumaConversa: React.FC = () => (
    <div className={`${rootClassName}-noChat`}>
      <DialogIcon />
      <Typography>
        {translation.AssessorMensagens['nenhuma-conversa']}
      </Typography>
    </div>
  );

  const verificarEmResposta = () => {
    const result = conversaAtual?.duvidas.some((x) => {
      return x.flgEmResposta === true && x.ldapResposta !== usuario?.ldap;
    });

    return result;
  };

  useEffect(() => {
    setDuvida(undefined);
  }, [conversaAtual]);

  return (
    <ChatContext.Provider
      value={{
        duvidaAtual,
        setDuvida,
        respostaPadraoResponse,
        setRespostaPadraoResponse,
      }}
    >
      <div className={rootClassName}>
        <div
          className={
            verificarEmResposta()
              ? `${rootClassName}-header em-resposta`
              : `${rootClassName}-header`
          }
        >
          <p>
            {conversaAtual
              ? conversaAtual?.nome
              : `${translation.AssessorMensagens['mensagem-nao-selecionada']}`}
          </p>
          {conversaAtual && !isNaN(parseFloat(conversaAtual?.cpfUsuario)) && (
            <p>CPF: {formatCPFOrCNPJ(conversaAtual?.cpfUsuario || '', true)}</p>
          )}

          {verificarEmResposta() && (
            <div className={`${rootClassName}-header-em-resposta`}>
              {translation.AssessorMensagens['mensagem-em-resposta']}
            </div>
          )}
        </div>

        {!conversaAtual ? (
          <NenhumaConversa />
        ) : (
          <Fragment>
            <div
              className={
                verificarEmResposta()
                  ? `${rootClassName}-conversa em-resposta`
                  : `${rootClassName}-conversa`
              }
            >
              {conversaAtual.duvidas
                .sort((a: any, b: any) => {
                  if (
                    (a.dataResposta > b.dataResposta, a.resposta && !b.resposta)
                  )
                    return 1;
                  if (
                    (a.dataResposta < b.dataResposta, !a.resposta && b.resposta)
                  )
                    return -1;
                  return 0;
                })
                .map((duvida) => {
                  return (
                    <Question
                      key={duvida.idDuvidaFrequente}
                      {...duvida}
                      isAdmin={
                        // (usuario?.perfil.id === 'pertencer_consulta' &&
                        //   !usuario.perfil.assessorRoute.duvidasSugestoes
                        //     .responder &&
                        //   evento?.tipo === 'REU') ||
                        conversaAtual.flgDestaque
                      }
                    />
                  );
                })}
            </div>
          </Fragment>
        )}
        <Responder />
      </div>
    </ChatContext.Provider>
  );
}
